(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var headerSelector = '#SiteHeader.eo-mobile-search';
  var inputSelector =
    'predictive-search input.search__input[name="q"]';
  var closeButtonSelector = '.btn--close-search';
  var visibleClass = 'eo-mobile-search__clear-visible';
  var originalPlaceholders = new WeakMap();

  function getHeaderInput(header) {
    return header ? header.querySelector(inputSelector) : null;
  }

  function getCloseButton(header) {
    return header ? header.querySelector(closeButtonSelector) : null;
  }

  function syncPlaceholder(header) {
    var input = getHeaderInput(header);

    if (!input) return;

    if (!originalPlaceholders.has(input)) {
      originalPlaceholders.set(
        input,
        input.getAttribute('placeholder') || ''
      );
    }

    input.setAttribute(
      'placeholder',
      mobileQuery.matches
        ? 'Search products...'
        : originalPlaceholders.get(input)
    );
  }

  function syncClearButton(header) {
    var input = getHeaderInput(header);
    var button = getCloseButton(header);

    if (!input || !button) return;

    var shouldShow = mobileQuery.matches && input.value.length > 0;

    button.classList.toggle(visibleClass, shouldShow);

    if (mobileQuery.matches) {
      button.setAttribute('aria-label', 'Clear search');
    } else {
      button.classList.remove(visibleClass);
      button.removeAttribute('aria-label');
    }
  }

  function syncAllClearButtons() {
    document.querySelectorAll(headerSelector).forEach(function (header) {
      syncPlaceholder(header);
      syncClearButton(header);
    });
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches(inputSelector)) return;

    var header = event.target.closest(headerSelector);
    if (!header) return;

    syncClearButton(header);
  });

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest(closeButtonSelector);
      if (!button || !mobileQuery.matches) return;

      var header = button.closest(headerSelector);
      if (!header) return;

      var input = getHeaderInput(header);
      if (!input) return;

      /*
       * Clear before the theme's native click handler runs. That handler
       * then closes results, removes the overlay, and restores the idle row.
       */
      event.preventDefault();
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.blur();
      syncClearButton(header);
    },
    true
  );

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncAllClearButtons);
  } else {
    mobileQuery.addListener(syncAllClearButtons);
  }

  document.addEventListener('shopify:section:load', syncAllClearButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllClearButtons, {
      once: true
    });
  } else {
    syncAllClearButtons();
  }
})();